<template>
    <GmapMap
        ref="mapRef"
        :center="map.center"
        :zoom="map.zoom"
        map-type-id="roadmap"
        :options="{
            mapTypeControl: false,
            gestureHandling: 'greedy',
        }">
        <GmapMarker
            v-for="(marker, index) in markers"
            :key="`map-marker-${index}`"
            :position="marker.position"
            :icon="getMarkerIcon(marker)"
        ></GmapMarker>
    </GmapMap>
</template>

<script>
import { getGoogleMapsAPI, components } from 'gmap-vue';
import { markerIconSelected } from '@components/Search/partials/markers';

export default {
    components: {
        GmapMap: components.MapLayer,
        GmapMarker: components.Marker,
    },
    props: {
        markers: {
            type: Array,
            required: true,
        },
        zoom: {
            type: Number,
            required: false,
            default: 15,
        },
        withZoomAnimation: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            map: {
                center: this.markers.find((item) => !item.is_nearby).position,
                zoom: 15,
            },
            mapZoom: 15,
            zoomAnimationInterval: null,
            zoomAnimationAmount: 6,
        };
    },
    async mounted() {
        await this.$gmapApiPromiseLazy();
        if (this.withZoomAnimation) {
            this.mapZoom = this.zoom - this.zoomAnimationAmount;
            this.map.zoom = this.mapZoom;
            setTimeout(() => {
                this.zoomAnimationInterval = setInterval(() => {
                    this.mapZoom += 1;
                    this.map.zoom = this.mapZoom;
                }, 250);
            }, 250);
        }
    },
    watch: {
        mapZoom(zoom) {
            if (this.withZoomAnimation && zoom >= this.zoom) {
                clearInterval(this.zoomAnimationInterval);
            }
        },
    },
    computed: {
        google: getGoogleMapsAPI,
    },
    methods: {
        getMarkerIcon(marker) {
            if (marker.icon && this.google) {
                return {
                    url: marker.icon,
                    size: new this.google.maps.Size(16, 16),
                    scaledSize: new this.google.maps.Size(16, 16),
                };
            }
            return markerIconSelected();
        },
    },
};
</script>
